import { Link, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import AnimatedRoutes, { absolute } from '../../components/AnimatedRoutes';
import { FloatingModal } from '../../components/Modal';
import { getImageUrl, navigate } from '../../../../helpers';
import BackgroundImage from '../../components/BackgroundImage';
import Button from '../../components/Button';
import Content from '../../components/Content';
import Header from '../../components/Header';
import Maps from '../Maps';
import Subheader from '../../components/Subheader';
import styles from './food.scss';
import withUser from '../../../../components/withUser';

const AbsoluteMap = absolute(Maps, true);

const propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    pub_exhibitors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })),
  }),
  // dispatch: PropTypes.func.isRequired,
  onRequestOpenFn: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    url: PropTypes.string,
    path: PropTypes.string,
  }).isRequired,
  // loading: PropTypes.bool,
};

const Food = ({
  event,
  history,
  location,
  onRequestOpenFn,
  match,
}) => {
  const unsortedPartners = (event && event.pub_exhibitors) || [];

  // Sort all exhibitors by alphabetical order.
  const partners = unsortedPartners.sort((a, b) => (
    (b.sort - a.sort) || a.name.localeCompare(b.name)
  )).filter((ex) => ex.type === 'restaurant');

  return (
    <>
      <Header
        onMenuOpen={onRequestOpenFn}
        history={history}
        showUser
      >
        Food & drinks
      </Header>
      <Content>
        <Subheader>
          Showing
          {' '}
          {partners?.length}
          {' '}
          food & drink locations
        </Subheader>
        <div className={styles.list}>
          { partners.map((partner) => (
            <div
              className={styles.food}
              key={partner.id}
              onClick={() => navigate(history, `${match.url}/${partner.id}`)}
              role="button"
              tabIndex={0}
            >
              <BackgroundImage
                className={styles.thumb}
                key={partner.id}
                src={getImageUrl(partner.image)}
              >
                { !partner.image
                  && <i className="far fa-utensils-alt" />}
              </BackgroundImage>
              <div className={styles.content}>
                <div className={styles.name}>
                  {partner.name}
                </div>
                { partner.description
                  && (
                  <div className={styles.description}>
                    {partner.description?.length > 65 ? `${partner.description.substring(0, 65)}...` : partner.description}
                  </div>
                  )}
                { partner.distance
                  && (
                  <div className={styles.distance}>
                    { partner.distance === '0'
                      ? <span>Inside the venue</span>
                      : (
                        <span>
                          {partner.distance}
                          {' '}
                          from the venue
                        </span>
                      )}
                  </div>
                  )}
              </div>
            </div>
          ))}
        </div>
      </Content>
      <Route
        exact
        path={`${match.path}/:id`}
        render={(props) => {
          const activePartner = props.match.params.id && partners
            && partners.find(
              (partner) => partner.id === props.match.params.id,
            );

          return (
            <FloatingModal
              isOpen={!!activePartner}
              onRequestClose={() => navigate(history, match.url)}
            >
              { activePartner
                && (
                <div>
                  { activePartner.image
                    && (
                    <BackgroundImage
                      className={styles.activeBg}
                      src={getImageUrl(activePartner.image)}
                    />
                    )}
                  <div className={styles.activePartner}>
                    <div className={styles.activeTitle}>
                      {activePartner.name}
                    </div>
                    <div className={styles.activeDescription}>
                      {activePartner.description}
                    </div>
                    { activePartner.distance
                      && (
                      <div className={styles.activeDistance}>
                        { activePartner.distance === '0'
                          ? <span>Inside the venue</span>
                          : (
                            <span>
                              {activePartner.distance}
                              {' '}
                              from the venue
                            </span>
                          )}
                      </div>
                      )}
                    <div className={styles.activeActions}>
                      { (activePartner.area || activePartner.pin)
                        && (
                        <Button>
                          <Link to={`${match.url}/map/${activePartner.id}`}>
                            Show on map
                          </Link>
                        </Button>
                        )}
                      { !activePartner.area && activePartner.map_url
                        && (
                        <Button
                          onClick={() => window.open(activePartner.map_url)}
                        >
                          Get directions
                        </Button>
                        )}
                      {
                        activePartner.url
                        && (
                        <Button
                          outline
                          onClick={() => window.open(activePartner.url)}
                        >
                          Visit website
                        </Button>
                        )
                      }
                    </div>
                  </div>
                </div>
                )}
            </FloatingModal>
          );
        }}
      />
      <AnimatedRoutes location={location}>
        <Route exact path={`${match.path}/map/:exhibitor`} render={(props) => (<AbsoluteMap {...props} />)} />
      </AnimatedRoutes>
    </>
  );
};

Food.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['event', 'loading']),
    event: state.getIn(['event', 'data']),
  };
}

export default withUser(connect(mapStateToProps)(Food));
